"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDataType = void 0;
/**
 * Defines which type of getData call to make.
 */
var GetDataType;
(function (GetDataType) {
    GetDataType["Summary"] = "summary";
    GetDataType["Underlying"] = "underlying";
})(GetDataType || (exports.GetDataType = GetDataType = {}));
//# sourceMappingURL=GetDataService.js.map